import Settings from './settings'

export default {
  ...Settings,
  urlHotFolder: '',
  webSocketUrl: 'wss://test-toyota.idoccar.com:8006',
  notificationRefresh: 60000,
  showSignDocumentButton: false,
  acceptFileFormats: 'application/pdf, .jpg, .png, .jpeg, .gif, .docx, .doc, .xls, .xlsx, .ppt, .pptx, .msg, .tiff',
  qaSite: true,
  dealerMaxLength: 6,
  dealerNumberRegex: null,
  autoLoadDashboard: true,
  clientFieldValidation: 'toyo',
  validateLicensePlate: true,
  matomoSiteId: '30',
  enableFavoritesAndRecents: true,
  enableTaskFollowUp: true,
  dashboardVersion: 2,
  validateSalesManager: false,
  reloadTaskDashboardOnReturn: true,
  usersManualUrl: 'https://toyota-formacion-new.idoccar.com/',
  usersManualEnvironment: 'preprotoyota',
  environmentName: 'pre-toyota',
  showV2Link: true
}
